import { createAction, props } from '@ngrx/store';

import type { SmartChargingLeadWidgetStep } from './smart-charging-lead.reducer';

const SMART_CHARGING_LEAD_ACTION = '[Smart Charging Lead]';

export const activateSmartChargingLeadStep = createAction(
  `${SMART_CHARGING_LEAD_ACTION} Activate step`,
  props<{ step: SmartChargingLeadWidgetStep }>()
);

export const sendSmartChargingLead = createAction(
  `${SMART_CHARGING_LEAD_ACTION} Send lead`
);
